import {
  CustomGetDailyFormVehiclesQuery,
  CustomGetDailyFormVehiclesQueryVariables,
  useCustomGetDailyFormVehiclesLazyQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormVehicles() {
  const [query, { data: graphqlData, error, loading, fetchMore: more }] =
    useCustomGetDailyFormVehiclesLazyQuery();

  const getDailyFormVehicles = useCallback(
    (variables: CustomGetDailyFormVehiclesQueryVariables) => {
      query({ variables });
    },
    [query]
  );

  const getData = useCallback((data?: CustomGetDailyFormVehiclesQuery) => {
    return data?.getDailyFormVehicles?.data || [];
  }, []);

  const getPaginatorInfo = useCallback((data?: CustomGetDailyFormVehiclesQuery) => {
    return data?.getDailyFormVehicles?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => getData(graphqlData), [getData, graphqlData]);
  const paginatorInfo = useMemo(() => getPaginatorInfo(graphqlData), [getPaginatorInfo, graphqlData]);

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  return [
    getDailyFormVehicles,
    { loading, data, error, getData, getPaginatorInfo, paginatorInfo, fetchMore },
  ] as const;
}
